<template>
  <div class="mb-home">
    <Carousel ref="carousel" :auto-play="false" height="11.58rem" width="100%" :imgs="imgs"></Carousel>
    <section class="pile">
      <div class="left">
        <img @click="() => $router.push({name: 'mProductPile1'})" :src="require('@/assets/mobile/pile1.png')"/>
        <div class="desc">
          <p>简约 时尚 智能</p>
          <p>全新上市</p>
        </div>
      </div>
      <div class="right">
        <div class="up" @click="() => $router.push({name: 'mServiceSupport'})">
          <img :src="require('@/assets/mobile/pile2.png')"/>
          <div class="desc">
            <p>服务支持</p>
            <p>极致的体验</p>
          </div>
        </div>
        <div class="down" @click="() => $router.push({name: 'mguide'})">
          <img :src="require('@/assets/mobile/pile3.png')"/>
          <div class="desc">
            <p>充电操作指引</p>
            <p>操作简便 安全高效</p>
          </div>
        </div>
      </div>
    </section>
    <section class="gw">
      <div class="pics">
        <div>
          <img :src="require('@/assets/mobile/gw1.png')"/>
          <p>享受 舒适</p>
        </div>
        <div>
          <img :src="require('@/assets/mobile/gw2.png')"/>
          <p>挑战 突破</p>
        </div>
        <div>
          <img :src="require('@/assets/mobile/gw3.png')"/>
          <p>社区 节能</p>
        </div>
        <div>
          <img :src="require('@/assets/mobile/gw4.png')"/>
          <p>热情 绽放</p>
        </div>
      </div>
    </section>
    <section></section>
  </div>
</template>
<script>
import Carousel from '@/components/Carousel'
export default {
  name: 'home',
  components: {
    Carousel
  },
  data () {
    return {
      imgs: [{ url: require('../../assets/mobile/home1.gif'), desc: ['智慧交流充电桩', '精工打造 至高品质'] },
        { url: require('../../assets/mobile/home2.png'), desc: ['智慧充电', '智能服务，畅享出行'] },
        { url: require('../../assets/mobile/home3.gif'), desc: ['智慧充电', '智慧充电云平台，为生活注入科技'] }],
      currentClientX: 0,
      currentClientY: 0
    }
  },
  methods: {
  }
}
</script>
<style lang="less">
.mb-home{
  overflow-x: hidden;
  .desc{
    &.home0, &.home1, &.home2{
      padding-top: 1.46rem;
      text-align: center;
      >div{
        &:first-child{
          font-size: 27px;
          line-height: 37.5px;
          color: #333;
          margin-bottom: .1rem;
        }
        &:last-child{
          font-size: 16px;
          line-height: 22.5px;
          color: #666;
        }
      }
    }
    &.home2{
      >div{
        color: #fff!important;
      }
    }
  }
  .pile{
    width: 6.94rem;
    height: 3.78rem;
    margin: .27rem auto .36rem;
    display: flex;
    justify-content: space-around;
    .left{
      position: relative;
      flex: 0 0 3.4rem;
      height: 3.78rem;
      overflow: hidden;
      img{
        width: 3.4rem;
        height: 3.78rem;
      }
      .desc{
        width: 100%;
        position: absolute;
        top: .2rem;
        text-align: center;
        p{
          &:first-child{
            font-size: .28rem;
            line-height: .4rem;
            color: #FFF;
            margin-bottom: .07rem;
          }
          &:last-child{
            font-size: .24rem;
            line-height: .33rem;
            color: #13E4E8;
          }
        }
      }
    }
    .right{
      display: flex;
      flex-direction: column;
      flex: 0 0 3.4rem;
      >div{
        position: relative;
        height: 1.84rem;
        img{
          width: 3.4rem;
          height: 1.84rem;
        }
        .desc{
          width: 100%;
          position: absolute;
          top: .24rem;
          text-align: center;
        }
        &.up{
          margin-bottom: .11rem;
        }
        &.up .desc p{
          &:nth-child(1){
            font-size: .24rem;
            line-height: .33rem;
            color: #081530;
          }
          &:nth-child(2){
            font-size: .18rem;
            line-height: .24rem;
            color: #6D7278;
          }
        }
        &.down .desc p{
          &:nth-child(1){
            font-size: .24rem;
            line-height: .33rem;
            color: #fff;;
          }
          &:nth-child(2){
            font-size: .18rem;
            line-height: .24rem;
            color: #fff;
            opacity: .6;
          }
        }
      }
    }
  }
  .gw{
    width: 7.08rem;
    margin: 0 auto .36rem;
    // h2{
    //   margin: 0;
    //   font-size: .50rem;
    //   line-height: .70rem;
    //   color: #000;
    // }
    // h4{
    //   font-size: .26rem;
    //   line-height: .37rem;
    //   color: #6D7278;
    //   margin: .1rem 0 .6rem;
    // }
    .pics{
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-around;
      div{
        flex:0 0 3.4rem;
        height: 2.73rem;
        img{
          width: 3.4rem;
          height: 2.02rem;
        }
        p{
          font-size: .24rem;
          line-height: .33rem;
          color: #081530;
          margin: -0.1rem 0 0 0;
        }
      }
    }
  }
}
</style>
